import React, { useState , useEffect} from "react";


import "./affiliate-dashboard.css";

const Widget = (props) => {
    return (

        <div className="wizard_inner impressions">
            <div className="wizard_inner_inner ">
                <div className="wizard_overlay">
                    <h3>{props.header}</h3>
                    <p>{props.subHeader}</p>
                    <img src={props.icon} />
                </div>
            </div>
        </div>
        );
    };
    export default Widget;